import { OtpResendProps } from "./otp.types";

export const OTP_RESEND_DEFAULT_PROPS: Omit<OtpResendProps, "seed"> = {
  duration: 60,
  resend_event: "",
  resend_button_label: "Resend code",
  count_down_text: "Resend code in ",
};
